'use client';

import { c as _c } from "react/compiler-runtime";
import { LoadingSpinner } from '@/comps/loading-spinner';
import { LoadingStatus } from '@/comps/primitives/loading-status';
import { Skeleton } from '@/comps/primitives/skeleton';
import { AppShellToolbarSeparator, APP_SHELL_TOOLBAR_ROW_CLASS } from '@/comps/tabs/TableHeaderToolsContainer';
import { AppShellRailSkeleton } from '@/domains/dashboard/components/app-shell-rail-skeleton';
import { SidebarNavRowSkeleton } from '@/domains/dashboard/components/sidebar-nav-row';
import { cn } from '@/utils/shad';
import { translateSafe } from '@/utils/translations';
import { SearchIcon } from 'lucide-react';
type AppShellBootSkeletonProps = {
  /** Shared-link views have no sidebar/footer; omit them so nothing has to disappear once the real shell mounts. */
  isSharedLink?: boolean;
};
export function AppShellBootSkeleton(t0) {
  const $ = _c(10);
  const {
    isSharedLink: t1
  } = t0;
  const isSharedLink = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isSharedLink) {
    t2 = !isSharedLink && <><AppShellRailSkeleton /><section aria-hidden={true} className="flex h-full min-w-51.75 flex-col border-r bg-muted/30"><div className={cn(APP_SHELL_TOOLBAR_ROW_CLASS, "px-4")}><button type="button" disabled={true} className="flex h-8 w-full min-w-0 items-center gap-2 overflow-hidden rounded-md px-2 text-left text-[13px] font-normal tracking-[-0.31px] text-muted-foreground disabled:pointer-events-none disabled:opacity-50"><SearchIcon className="size-3 shrink-0 text-[rgba(161,161,170,1)]" aria-hidden={true} /><span className="min-w-0 truncate font-medium text-custom-500/80">{translateSafe("platform", "search")}</span><Skeleton className="ml-auto h-5 w-10 shrink-0 rounded-full" /></button></div><AppShellToolbarSeparator /><div className="flex flex-col gap-1 px-2 py-3"><SidebarNavRowSkeleton /><SidebarNavRowSkeleton /><SidebarNavRowSkeleton /><SidebarNavRowSkeleton /></div></section></>;
    $[0] = isSharedLink;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <main aria-hidden={true} className="relative flex min-h-0 grow basis-0 flex-col bg-background"><LoadingSpinner fullContainer={true} /></main>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isSharedLink) {
    t4 = !isSharedLink && <footer aria-hidden={true} className="h-12 shrink-0 border-t bg-background" />;
    $[3] = isSharedLink;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <div className="relative flex min-h-0 grow basis-0 flex-col overflow-x-auto">{t3}{t4}</div>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t5) {
    t6 = <LoadingStatus><div className="flex h-full w-full flex-col"><div className="flex min-h-0 grow overflow-hidden">{t2}{t5}</div></div></LoadingStatus>;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}